import { GqlBolagoFile } from '../../graphql/base-types.graphql';

export const getFileUrl = (
  bolagoFile: Pick<GqlBolagoFile, 'id' | 'filename'>,
  contentDisposition: 'inline' | 'attachment' | null,
) => {
  const query = contentDisposition ? `?contentDisposition=${contentDisposition}` : '';
  return `/documents/file/${bolagoFile.id}/${encodeURIComponent(bolagoFile.filename)}${query}`;
};
